var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkInitialBtn2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 77,
    viewBox: "0 0 230 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.558105C0 0.558105 201.991 0.558105 207.453 0.558105C218.801 0.558105 218.801 11.298 218.801 11.298H10.0824C10.0824 15.2135 10.0824 52.0114 10.0824 57.277C10.0824 63.1502 13.0253 66.9307 19.7469 66.9307C26.4685 66.9307 219.637 66.5133 219.637 66.5133V11.0096C219.637 11.0096 229.301 12.6911 229.301 19.8224C229.301 26.9598 229.301 76.5781 229.301 76.5781C229.301 76.1608 27.7341 76.5781 17.2279 76.5781C6.72157 76.5781 0 70.2815 0 58.9463C0 49.0595 0 0.558105 0 0.558105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkInitialBtn2);
export default __webpack_public_path__ + "static/media/dark-initial-btn-2.aacc44faaaa115da837d814c77b07409.svg";
export { ForwardRef as ReactComponent };